import { render, staticRenderFns } from "./ConnectButton.vue?vue&type=template&id=98f6d0c0&"
import script from "./ConnectButton.vue?vue&type=script&lang=js&"
export * from "./ConnectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports